module.exports = __webpack_public_path__ + "img/requisitions-green-icon.603e9534.svg";